<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Carrinho</p>
      <button type="button" class="delete" @click="$parent.close()" />
    </header>

    <section class="modal-card-body">
      <p
        class="transaction-id"
        @click="copyContent(transaction._id, 'ID da transação copiado!')"
      >
        <b>ID transação: </b>
        {{ transaction._id }}
        <b-icon icon="copy"></b-icon>
      </p>
      <br />

      <div
        v-for="item in transaction.cart.items"
        :key="item._id"
        class="cart-item"
      >
        <p>
          {{ `${item.quantity} x R$${formatMoney(item.price)} - ${item.name}` }}
        </p>
        <cart-item-combo :item="item" />
      </div>

      <hr />

      <p>
        <b>Total: </b>
        {{ `R$${formatMoney(transaction.cart.totalValue)}` }}
      </p>

      <div v-if="transaction.details.origin == 'vending'">
        <hr />
        <b>
          Log da entrega:
          {{ transaction.vending.vendingLog.length === 0 ? "-" : "" }}
        </b>

        <br /><br />

        <p v-for="log in transaction.vending.vendingLog" :key="log.logDate">
          {{ `${log.logDate} - ${log.description}` }}
          {{
            log.item ? ` - ${log.item.name} [slot ${log.item.slots[0]}]` : ""
          }}
        </p>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Fechar
      </button>
    </footer>
  </div>
</template>

<script>
import { mask } from "../../../mixins/mask";
import { common } from "../../../mixins/common";
import cartItemCombo from "./CartItemCombo.vue";

export default {
  props: ["transaction"],

  mixins: [mask, common],

  components: {
    cartItemCombo
  }
};
</script>

<style scoped>
.cart-item + .cart-item {
  margin-top: 0.375rem;
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.adyen-id {
  text-align: center;
  padding-bottom: 1rem;
}
.transaction-id {
  cursor: pointer;
  text-align: center;
  padding-bottom: 1rem;
  border-bottom: 1px dashed #dbdbdb;
}
</style>
